export * from 'src/constants/sidebar';
export const WINDOW_RESIZE_DEBOUNCE_DELAY = 300;
export const HORIZONTAL_NAVIGATION_MOBILE_HEADER_ACTIVE_WIDTH = 768;
export const UP_TO_SMALL_BREAKPOINT_ACTIVE_WIDTH = 576;
